import { render, staticRenderFns } from "./ProjectCategoryNewForm.vue?vue&type=template&id=3614d1b6"
import script from "./ProjectCategoryNewForm.vue?vue&type=script&lang=js"
export * from "./ProjectCategoryNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports